import { isset } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class SelectPaymentMethod extends React.Component {
  constructor(props) {
    super(props)

    this.selectPaymentMethod = null
    this.setSelectRef = (element) => {
      this.selectPaymentMethod = element
    }
    this.nextButton = this.nextButton.bind(this)
    this.setPaymentMethodId = this.setPaymentMethodId.bind(this)
    this.getPaymentMethodById = this.getPaymentMethodById.bind(this)
    this.newPaymentMethod = this.newPaymentMethod.bind(this)
    this.getOptions = this.getOptions.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Select Payment Method")
  }

  setPaymentMethodId(event) {
    this.props.setGlobalState({
      selectedPaymentMethod: this.getPaymentMethodById(event.target.value),
    })
  }

  nextButton() {
    if (!isset(this.props.state.selectedPaymentMethod)) {
      this.props.setGlobalState({
        selectedPaymentMethod: this.getPaymentMethodById(
          this.selectPaymentMethod.value
        ),
      })
    }
    this.props.setGlobalState({ paymentMethodCreated: "previously" })
    this.props.routeTo("next")
  }

  getPaymentMethodById(paymentMethodId) {
    const paymentMethod = this.props.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.stripePaymentMethodId === paymentMethodId
    )

    if (paymentMethod) return paymentMethod

    this.newPaymentMethod()
  }

  newPaymentMethod() {
    this.props.routeTo("AddPaymentMethod")
  }

  getOptions() {
    return this.props.state.paymentMethods.map((paymentMethod) => (
      <option
        key={paymentMethod.id}
        value={paymentMethod.stripePaymentMethodId}
      >
        {paymentMethod.title} {paymentMethod.subtitle}
      </option>
    ))
  }

  render() {
    const { selectedPaymentMethod } = this.props.state

    return (
      <div id="selectPaymentMethodContainer" className="select-payment-method">
        <div className="form-group">
          <label htmlFor="selectPaymentMethod">Your Payment Methods</label>
          <select
            id="selectPaymentMethod"
            className="form-control"
            value={
              selectedPaymentMethod &&
              selectedPaymentMethod.stripePaymentMethodId
            }
            onChange={this.setPaymentMethodId}
            ref={this.setSelectRef}
            autoFocus
          >
            {this.getOptions()}
          </select>
        </div>
        <button
          id="selectPaymentMethod"
          type="button"
          className="btn btn-primary"
          onClick={this.nextButton}
        >
          Select Payment Method
        </button>
        <button
          id="addPaymentMethod"
          type="button"
          className="btn btn-secondary"
          onClick={this.newPaymentMethod}
        >
          Add New Payment Method
        </button>
      </div>
    )
  }
}

SelectPaymentMethod.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  state: PropTypes.shape({
    paymentMethods: PropTypes.array.isRequired,
    selectedPaymentMethod: PropTypes.object,
  }).isRequired,
}

export default SelectPaymentMethod
